module.exports = __webpack_public_path__ + "img/cs.85c02c2d.png";